(function ($) {

  var flyout = $('.js-nav-flyout');

  if(flyout.length > 0) {

    listFlyout();

  }

  function listFlyout() {

    flyout.each(function(){

      var _this = $(this);
      var wrapper = _this.parent();
      var wrapperHeight = wrapper.outerHeight();
      var wrapperDistance = 10;
      var wrapperTopPosition = wrapper.offset().top + wrapperHeight + wrapperDistance;
      var wrapperLeftPosition = wrapper.offset().left;

      wrapper.hover(function(){
        _this.fadeIn(0);
      }, function() {
        _this.fadeOut(0);
      });

      _this.hover(function(){
        _this.fadeIn(0);
      }, function() {
        _this.fadeOut(0);
      });

      _this.css({
        'position' : 'absolute',
        'top'      : wrapperTopPosition,
        'left'     : wrapperLeftPosition,
        'z-index'  : 1000
      });

      _this.appendTo('body');

    })


  }

})(jQuery);
